import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import ISearch from '../../interface/ISearch'
import {useTranslation} from 'react-i18next'
import {Stack} from '@mui/material'

export default function Search({search, handleSearch}: ISearch) {
  const {t} = useTranslation()

  return (
    <Stack maxWidth={'230px'} alignItems={'center'} direction={'row'} className='form-control'>
      <Stack alignItems={'center'} justifyContent={'center'} m='0 5px'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500  '
        />
      </Stack>
      <input
        value={search}
        onChange={handleSearch}
        style={{
          // textIndent: '2rem',
          border: 'none',
          outline: 'none',
          width: '100%',
          marginTop: '5px',
        }}
        //    value={search}
        type='text'
        // className='form-control'
        name='search'
        //    onChange={handleSearch}
        placeholder={t('search') || 'search'}
      />
    </Stack>
  )
}
